import Pagenation from './Pagenation';
export default Pagenation;



// WEBPACK FOOTER //
// ./src/components/pagenation/index.js